module.exports = __webpack_public_path__ + "media/images/payments/discover-dark-9f8e248d6e1a98b738dbc5de8efd3cec.svg";